"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBadRequest = isBadRequest;
exports.isForbidden = isForbidden;
exports.isNotFound = isNotFound;
exports.isOk = isOk;
exports.isServerError = isServerError;
exports.isUnauthorized = isUnauthorized;
const sonar_http_1 = require("@sonar-software/sonar-http");
// FUTURE: Remove once manual saga declarations have been converted.
/** @deprecated */
function isStatus(actualStatus, expectedStatus) {
    return actualStatus === expectedStatus;
}
/** @deprecated */
function isBadRequest(status) {
    return isStatus(status, sonar_http_1.ErrorOrFailStatusCode.BadRequest);
}
/** @deprecated */
function isForbidden(status) {
    return isStatus(status, sonar_http_1.ErrorOrFailStatusCode.Forbidden);
}
/** @deprecated */
function isNotFound(status) {
    return isStatus(status, sonar_http_1.ErrorOrFailStatusCode.NotFound);
}
/** @deprecated */
function isOk(status) {
    return isStatus(status, sonar_http_1.SuccessStatusCode.Ok);
}
/** @deprecated */
function isServerError(status) {
    return isStatus(status, sonar_http_1.ErrorOrFailStatusCode.ServerError);
}
/** @deprecated */
function isUnauthorized(status) {
    return isStatus(status, sonar_http_1.ErrorOrFailStatusCode.Unauthorized);
}
//# sourceMappingURL=lib.js.map